export default "__VITE_ASSET__d8ba1ff6__"